import { UploadFormData } from '@dynamika-shared/types/validationSpecialist';

export const isVSSchema = (schema?: UploadFormData): boolean =>
  schema?.uiSchema?.formType === 'VS';
